import { render, staticRenderFns } from "./ppBase.vue?vue&type=template&id=5df86040&scoped=true"
import script from "./ppBase.vue?vue&type=script&lang=js"
export * from "./ppBase.vue?vue&type=script&lang=js"
import style0 from "./ppBase.vue?vue&type=style&index=0&id=5df86040&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df86040",
  null
  
)

export default component.exports